// src/providers/GlobalProviders.jsx

import React from "react";

import { Provider as ReduxProvider } from "react-redux";
import store from "./store";

import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import { MetreaProvider } from "@metrea-ui/v2";
import { ravenSystem } from "../theme";
import { RavenStyleGlobalReset } from "../styles/RavenStyleGlobalReset";

import { DialogProvider } from "./DialogProvider";
import { LookupsProvider } from "../context/LookupsContext";

/**
 * Wraps the application in all top-level context providers.
 * Includes Metrea UI, Redux, Router, and Lookups.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - App contents to render
 * @param {object} props.instance - MSAL PublicClientApplication instance
 */
export default function GlobalProviders({ children, instance }) {
	return (
		<ReduxProvider store={store}>
			<MsalProvider instance={instance}>
				<MetreaProvider system={ravenSystem}>
					<RavenStyleGlobalReset />
					<DialogProvider>
						<LookupsProvider>
							<BrowserRouter>{children}</BrowserRouter>
						</LookupsProvider>
					</DialogProvider>
				</MetreaProvider>
			</MsalProvider>
		</ReduxProvider>
	);
}
